import { clsx } from "clsx";

import type { JSX } from "react";

interface BadgeWrapperProps {
  children: JSX.Element;
  badgeClassName: string;
}

export default function BadgeWrapper({
  children,
  badgeClassName,
}: BadgeWrapperProps) {
  return (
    <div className="relative">
      {children}
      <div
        className={clsx(
          "absolute rounded-full border bg-purple-500 border-white",
          badgeClassName,
        )}
      />
    </div>
  );
}
